let sizeMap = {
  xsm: 100,
  sm: 300,
  md: 600,
  lg: 800,
} as const;

export type ImageResizeType = keyof typeof sizeMap;

export const resizeImage = (key: string, size: ImageResizeType = "sm") => {
  try {
    const url = new URL(key ?? "");
    const pathParts = url.pathname.split("/");

    const insertIndex = 1;
    pathParts.splice(insertIndex, 0, `resized/${size}`);

    url.pathname = pathParts.join("/");
    return url.toString();
  } catch (error: any) {
    console.error("Error processing URL:", error.message);
    return null;
  }
};

export const getIconsUrl = (key: string) => {
  return key;
};

export const resizeMultipleImages = (
  keys?: string[],
  size: ImageResizeType = "sm"
) => {
  if (!keys) return [];
  let resizedUrls: string[] = [];
  for (const key of keys) {
    try {
      resizedUrls.push(resizeImage(key, size) ?? "");
    } catch (error: any) {
      // resizedUrls.push(urlBase + key);
      console.error("Error processing URL:", error.message);
    }
  }
  console.log("🚀 ~ resizedUrls:", resizedUrls);
  return resizedUrls;
};
export const getIconUrls = (keys?: string[]) => {
  if (!keys) return [];

  let resizedUrls: string[] = [];

  for (const key of keys) {
    try {
      const parsedUrl = new URL(key);
      resizedUrls.push(parsedUrl.pathname.substring(1));
    } catch {
      resizedUrls.push(key);
    }
  }

  console.log("🚀 ~ resizedUrls:", resizedUrls);
  return resizedUrls;
};

// Example usage
